module.exports = __webpack_public_path__ + "static/img/sidebar-7.54b7c95c.jpg";